import { render, staticRenderFns } from "./tenderDocumentClarification.vue?vue&type=template&id=048b16a4&scoped=true"
import script from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
export * from "./tenderDocumentClarification.vue?vue&type=script&lang=js"
import style0 from "./tenderDocumentClarification.vue?vue&type=style&index=0&id=048b16a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b16a4",
  null
  
)

export default component.exports